import { useMutation } from "urql";

import { UpdateLimitRequestExceptionDocument } from "../../../graphql/generated.ts";

export const useUpdateLimitRequestException = () =>
  useMutation(UpdateLimitRequestExceptionDocument);
